var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternal)?_c('div',_vm._g({staticClass:"svg-external-icon svg-icon",style:(_vm.styleExternalIcon)},_vm.$listeners)):_c('svg',_vm._g({class:_vm.svgClass,attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.iconName}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-55f46888","hasScoped":true,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SvgIcon/index.vue
// module id = 1277
// module chunks = 72